import { render, staticRenderFns } from "./copy-form.vue?vue&type=template&id=79bba552&scoped=true"
import script from "./copy-form.vue?vue&type=script&lang=js"
export * from "./copy-form.vue?vue&type=script&lang=js"
import style0 from "./copy-form.vue?vue&type=style&index=0&id=79bba552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bba552",
  null
  
)

export default component.exports